// import React from 'react';
// import { motion } from 'framer-motion';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Autoplay, Pagination, Navigation } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/pagination';
// import 'swiper/css/navigation';

// const clientsData = [
//   {
//     id: 1,
//     name: "Gowtham Amarjothi Group Cheeyyar",
//     logo: "/assets/img/gowtham_finance_logo.png",
//   },
//   {
//     id: 2,
//     name: "Keerthiram Chits Funds pvt",
//     logo: "/assets/img/Keerthiram-Logo.jpg",
//   },
//   {
//     id: 3,
//     name: "Dindugal Gopuram Chits.",
//     logo: "/assets/img/Dindugal-chits-logo.png",
//   },
//   {
//     id: 4,
//     name: "Quality Joseph chits Madurai",
//     logo: "/assets/img/Quality-chits-logo.png",
//   },
//   {
//     id: 5,
//     name: "Sri Nithyakalyani Chits",
//     logo: "/assets/img/Sri-Nithya-chits-logo.png",
//   },
//   {
//     id: 6,
//     name: "Myfruitz",
//     logo: "/assets/img/Myfruitz-logo.png",
//   },
//   {
//     id: 7,
//     name: "Asb & sons",
//     logo: "/assets/img/asb_logo.jpg",
//   },
//   {
//     id: 8,
//     name: "Dreammakker hr solution",
//     logo: "/assets/img/dreammaker-logo.png",
//   },
//   {
//     id: 9,
//     name: "Mahalakshmi furniture",
//     logo: "/assets/img/Mahalakshmai-Logo.jpeg",
//   },
//   {
//     id: 10,
//     name: "Sun promoters",
//     logo: "/assets/img/sun-promotors-logo.png",
//   },
//   {
//     id: 11,
//     name: "Gmark home appliances",
//     logo: "/assets/img/gmark-logo.png",
//   },
// ];

// // Fallback component for missing or broken logos
// const LogoFallback = ({ name }) => {
//   const initials = name
//     .split(' ')
//     .map(word => word[0])
//     .join('')
//     .slice(0, 2)
//     .toUpperCase();

//   return (
//     <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary/10 to-primary/30 text-primary font-bold text-xl rounded-lg">
//       {initials}
//     </div>
//   );
// };

// const Clients = () => {
//   return (
//     <section id="our-clients" className="py-24 bg-white relative overflow-hidden">
//       {/* Decorative background element */}
//       <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-primary/20 to-transparent" />

//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Section Header */}
//         <motion.div
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: true }}
//           transition={{ duration: 0.8 }}
//           className="text-center mb-20"
//         >
//           <h2 className="text-4xl lg:text-5xl font-extrabold text-dark mb-6 tracking-tight">
//             Our <span className="text-primary italic">Trusted</span> Partners
//           </h2>
//           <p className="text-gray-500 max-w-2xl mx-auto text-lg">
//             Collaborating with industry-leading brands to deliver excellence across every project.
//           </p>
//         </motion.div>

//         {/* Improved Logo Spotlight Slider */}
//         <motion.div
//           initial={{ opacity: 0 }}
//           whileInView={{ opacity: 1 }}
//           viewport={{ once: true }}
//           transition={{ duration: 1, delay: 0.2 }}
//           className="relative group"
//         >
//           <Swiper
//             modules={[Autoplay, Pagination, Navigation]}
//             spaceBetween={24}
//             slidesPerView={2}
//             loop={true}
//             autoplay={{
//               delay: 3500,
//               disableOnInteraction: false,
//             }}
//             pagination={{
//               clickable: true,
//               el: '.clients-dots',
//             }}
//             navigation={{
//               nextEl: '.swiper-button-next-clients',
//               prevEl: '.swiper-button-prev-clients',
//             }}
//             breakpoints={{
//               640: {
//                 slidesPerView: 3,
//                 spaceBetween: 30,
//               },
//               1024: {
//                 slidesPerView: 4,
//                 spaceBetween: 40,
//               },
//               1280: {
//                 slidesPerView: 5,
//                 spaceBetween: 50,
//               },
//             }}
//             className="pb-24 clients-swiper"
//           >
//             {clientsData.map((client) => (
//               <SwiperSlide key={client.id}>
//                 <div className="flex flex-col items-center group/card transition-all duration-300">
//                   {/* Glassmorphism Card for Logo */}
//                   <div className="w-full aspect-[4/3] bg-gray-50/50 backdrop-blur-sm rounded-2xl border border-gray-100 flex items-center justify-center p-6 mb-6 transition-all duration-500 group-hover/card:bg-white group-hover/card:shadow-xl group-hover/card:border-primary/20 group-hover/card:-translate-y-2 group-hover/card:scale-105">
//                     <div className="w-full h-full relative overflow-hidden flex items-center justify-center">
//                        <img
//                         src={client.logo}
//                         alt={client.name}
//                         // className="max-w-full max-h-full object-contain filter grayscale opacity-60 group-hover/card:grayscale-0 group-hover/card:opacity-100 transition-all duration-700 pointer-events-none"
//                          className="max-w-full max-h-full object-contain transition-all duration-700 pointer-events-none group-hover/card:scale-110"
//                         onError={(e) => {
//                           e.target.style.display = 'none';
//                           e.target.nextElementSibling.style.display = 'flex';
//                         }}
//                       />
//                       <div className="hidden absolute inset-0">
//                         <LogoFallback name={client.name} />
//                       </div>
//                     </div>
//                   </div>

//                   {/* Highly Premium Name Styling */}
//                   <h3 className="text-center text-sm font-bold text-gray-400 group-hover/card:text-primary transition-colors duration-300 px-4 uppercase tracking-wider leading-tight">
//                     {client.name}
//                   </h3>
//                 </div>
//               </SwiperSlide>
//             ))}
//           </Swiper>

//           {/* <div className="flex justify-center gap-6 mt-4">
//             <button className="swiper-button-prev-clients w-12 h-12 rounded-full border border-gray-200 flex items-center justify-center text-gray-400 hover:text-primary hover:border-primary transition-all duration-300 hover:scale-110">
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
//               </svg>
//             </button>
//             <button className="swiper-button-next-clients w-12 h-12 rounded-full border border-gray-200 flex items-center justify-center text-gray-400 hover:text-primary hover:border-primary transition-all duration-300 hover:scale-110">
//               <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
//               </svg>
//             </button>
//           </div> */}

//           {/* Custom Modern Dots Pagination */}
//           <div className="clients-dots flex justify-center gap-2 mt-8" />
//         </motion.div>
//       </div>

//       <style jsx="true">{`
//         .clients-swiper :global(.swiper-pagination-bullet) {
//           width: 8px;
//           height: 8px;
//           background: #d1d5db;
//           opacity: 1;
//           transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
//         }
//         .clients-swiper :global(.swiper-pagination-bullet-active) {
//           width: 32px;
//           background: #E53935;
//           border-radius: 4px;
//         }

//         .clients-swiper {
//           mask-image: linear-gradient(to right, transparent, black 15%, black 85%, transparent);
//         }

//         @media (max-width: 768px) {
//           .clients-swiper {
//             mask-image: none;
//           }
//         }
//       `}</style>
//     </section>
//   );
// };

// export default Clients;

import React from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination} from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const clientsData = [
  {
    id: 1,
    name: "Gowtham Amarjothi Group Cheeyyar",
    logo: "/assets/img/gowtham_finance_logo.png",
  },
  {
    id: 2,
    name: "Keerthiram Chits Funds pvt",
    logo: "/assets/img/Keerthiram-Logo.jpg",
  },
  {
    id: 3,
    name: "Dindugal Gopuram Chits.",
    logo: "/assets/img/Dindugal-chits-logo.png",
  },
  {
    id: 4,
    name: "Quality Joseph chits Madurai",
    logo: "/assets/img/Quality-chits-logo.png",
  },
  {
    id: 5,
    name: "Sri Nithyakalyani Chits",
    logo: "/assets/img/Sri-Nithya-chits-logo.png",
  },
  {
    id: 6,
    name: "Myfruitz",
    logo: "/assets/img/Myfruitz-logo.png",
  },
  {
    id: 7,
    name: "Asb & sons",
    logo: "/assets/img/asb_logo.jpg",
  },
  {
    id: 8,
    name: "Dreammakker hr solution",
    logo: "/assets/img/dreammaker-logo.png",
  },
  {
    id: 9,
    name: "Mahalakshmi furniture",
    logo: "/assets/img/Mahalakshmai-Logo.jpeg",
  },
  {
    id: 10,
    name: "Sun promoters",
    logo: "/assets/img/sun-promotors-logo.png",
  },
  {
    id: 11,
    name: "Gmark home appliances",
    logo: "/assets/img/gmark-logo.png",
  },
];

// Fallback component for missing or broken logos
const LogoFallback = ({ name }) => {
  const initials = name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <div className="w-full h-full flex items-center justify-center bg-gray-50 text-primary font-bold text-lg rounded-lg border border-dashed border-gray-200">
      {initials}
    </div>
  );
};

const Clients = () => {
  return (
    <section
      id="our-clients"
      className="py-20 bg-white relative overflow-hidden"
    >
      {/* Decorative background element */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-extrabold text-dark mb-4 tracking-tight uppercase">
            {/* Trusted by{" "}
            <span className="text-primary italic">Leading Clients</span> */}

            Working with <span className="text-primary italic">Our Clients</span>
          </h2>

          <div className="w-16 h-1 bg-primary mx-auto rounded-full mb-6" />
          <p className="text-gray-500 max-w-xl mx-auto text-base">
            We collaborate with industry-leading brands to deliver high-quality
            solutions, building strong relationships based on trust, innovation,
            and results.
          </p>
        </motion.div>

        {/* Improved Logo Spotlight Slider - More compact */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.2 }}
          className="relative px-2 sm:px-0"
        >
          <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={20}
            slidesPerView={3}
            loop={true}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
              el: ".clients-dots",
            }}
            breakpoints={{
              640: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
              1280: {
                slidesPerView: 6,
                spaceBetween: 20,
              },
            }}
            className="pb-16 clients-swiper"
          >
            {clientsData.map((client) => (
              <SwiperSlide key={client.id}>
                <div className="flex flex-col items-center group/card transition-all duration-300">
                  {/* Glassmorphism Card for Logo - Compact & Square */}
                  <div className="w-full aspect-square bg-gray-50/30 backdrop-blur-xs rounded-xl border border-gray-100 flex items-center justify-center p-3 transition-all duration-500 group-hover/card:bg-white group-hover/card:shadow-lg group-hover/card:border-primary/30 group-hover/card:scale-105">
                    <div className="w-full h-full relative overflow-hidden flex items-center justify-center">
                      <img
                        src={client.logo}
                        alt={client.name}
                        className="max-w-full max-h-[85%] object-contain transition-all duration-700 pointer-events-none group-hover/card:scale-110"
                        onError={(e) => {
                          e.target.style.display = "none";
                          e.target.nextElementSibling.style.display = "flex";
                        }}
                      />
                      <div className="hidden absolute inset-0">
                        <LogoFallback name={client.name} />
                      </div>
                    </div>
                  </div>

                  {/* Subtle Name Styling - Reduced size */}
                  <h3 className="mt-4 text-center text-[11px] font-bold text-gray-500 group-hover/card:text-primary transition-colors duration-300 px-1 uppercase tracking-tighter leading-none opacity-80">
                    {client.name}
                  </h3>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Modern Dots Pagination */}
          <div className="clients-dots flex justify-center gap-1 mt-2" />
        </motion.div>
      </div>

      <style jsx="true">{`
        .clients-swiper :global(.swiper-pagination-bullet) {
          width: 6px;
          height: 6px;
          background: #d1d5db;
          opacity: 1;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .clients-swiper :global(.swiper-pagination-bullet-active) {
          width: 24px;
          background: #e53935;
          border-radius: 3px;
        }

        .clients-swiper {
          mask-image: linear-gradient(
            to right,
            transparent,
            black 10%,
            black 90%,
            transparent
          );
        }

        @media (max-width: 768px) {
          .clients-swiper {
            mask-image: none;
          }
        }
      `}</style>
    </section>
  );
};

export default Clients;
